
const Constants = {
   SetCurUser: 'user_setCurUser',
   SetTargetUser: 'user_setTargetUser',
   SetMessagesRead: 'user_setMessagesRead',
   SetIsCurrentUserFollowing: 'user_setIsCurrentUserFollowing',

};

exports.Reducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetCurUser:
         return {...state, curUser: action.userData};
      case Constants.SetTargetUser: {
         return {...state, targetUser: action.userData, isCurrentUserFollowing: action.isCurrentUserFollowing};
      }
      case Constants.SetIsCurrentUserFollowing: {
         return {...state, isCurrentUserFollowing: action.isCurrentUserFollowing};
      }
      case Constants.SetMessagesRead: {
         let user = {...state.curUser};
         user.unreadPrivateMessageCount = 0;
         return {...state, curUser: user};
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setCurUser = (userData) => {
   return{
      type: Constants.SetCurUser,
      userData
   }
};

FunctionList.setTargetUser = (userData, isCurrentUserFollowing) => {
   return{
      type: Constants.SetTargetUser,
      userData,
      isCurrentUserFollowing
   }
};

FunctionList.setIsCurrentUserFollowing = (isCurrentUserFollowing) => {
   return{
      type: Constants.SetIsCurrentUserFollowing,
      isCurrentUserFollowing
   }
};

FunctionList.setMessagesRead = () => {
   return{
      type: Constants.SetMessagesRead
   }
};

exports.FunctionList = FunctionList;
